// extracted by mini-css-extract-plugin
var _1 = "ConfirmationStyle-module__arrow-icon___uzbcb";
var _2 = "ConfirmationStyle-module__arrow-icon-big___Gt7lh";
var _3 = "ConfirmationStyle-module__arrow-icon___uzbcb";
var _4 = "ConfirmationStyle-module__arrow-icon-big___Gt7lh";
var _5 = "ConfirmationStyle-module__btn___iNzzs";
var _6 = "ConfirmationStyle-module__btn-active___fP2ZM";
var _7 = "ConfirmationStyle-module__btn-active-disabled___oREvl";
var _8 = "ConfirmationStyle-module__btn-block___igXxS";
var _9 = "ConfirmationStyle-module__btn-cancel___EV_5V";
var _a = "ConfirmationStyle-module__btn-disabled___J0mcW";
var _b = "ConfirmationStyle-module__btn-no-padding___vDRX8";
var _c = "ConfirmationStyle-module__btn-secondary___Sa3zG";
var _d = "ConfirmationStyle-module__btn-success___yBFZX";
var _e = "ConfirmationStyle-module__btn-success-disabled___VflGr";
var _f = "ConfirmationStyle-module__btn-transparent___DrCkE";
var _10 = "ConfirmationStyle-module__btn-active___fP2ZM";
var _11 = "ConfirmationStyle-module__btn-active-disabled___oREvl";
var _12 = "ConfirmationStyle-module__btn-block___igXxS";
var _13 = "ConfirmationStyle-module__btn-cancel___EV_5V";
var _14 = "ConfirmationStyle-module__btn-disabled___J0mcW";
var _15 = "ConfirmationStyle-module__btn-no-padding___vDRX8";
var _16 = "ConfirmationStyle-module__btn-secondary___Sa3zG";
var _17 = "ConfirmationStyle-module__btn-success___yBFZX";
var _18 = "ConfirmationStyle-module__btn-success-disabled___VflGr";
var _19 = "ConfirmationStyle-module__btn-transparent___DrCkE";
var _1a = "ConfirmationStyle-module__buttons___d49Ti";
var _1b = "ConfirmationStyle-module__cancel-button___xqK4P";
var _1c = "ConfirmationStyle-module__cancel-button-big___jrgNK";
var _1d = "ConfirmationStyle-module__cancel-button___xqK4P";
var _1e = "ConfirmationStyle-module__cancel-button-big___jrgNK";
var _1f = "ConfirmationStyle-module__container___B6dIF";
export { _1 as "arrow-icon", _2 as "arrow-icon-big", _3 as "arrowIcon", _4 as "arrowIconBig", _5 as "btn", _6 as "btn-active", _7 as "btn-active-disabled", _8 as "btn-block", _9 as "btn-cancel", _a as "btn-disabled", _b as "btn-no-padding", _c as "btn-secondary", _d as "btn-success", _e as "btn-success-disabled", _f as "btn-transparent", _10 as "btnActive", _11 as "btnActiveDisabled", _12 as "btnBlock", _13 as "btnCancel", _14 as "btnDisabled", _15 as "btnNoPadding", _16 as "btnSecondary", _17 as "btnSuccess", _18 as "btnSuccessDisabled", _19 as "btnTransparent", _1a as "buttons", _1b as "cancel-button", _1c as "cancel-button-big", _1d as "cancelButton", _1e as "cancelButtonBig", _1f as "container" }
